/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/ar-list';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        orderNumber: 40,
        transactionType: 100,
        originated: 180,
        status: 120,
        note: 120,
        debit: 40,
        credit: 40,
        balance: 40,

        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 40, // group actions column
    },
    filterFlyoutWidths: {
        status: 320
    },
    valueColors: {},
    actionIcons: {
        payNow: 'paymentCard'
    }
};
